












import moment from 'moment';

export default {
  // model: {
  //   prop: 'value',
  //   event: 'change'
  // },
  props: ['value', 'isSinglePark'],
  data() {
    return {
      rangePickerStart: null
    };
  },

  methods: {
    handleCalendarChange: function handleCalendarChange(current, other) {
      console.debug('$attrs', this.$attrs, this.$listeners, this.$props);

      if (current.length !== 1) return;
      try {
        this.rangePickerStart = moment(current[0].valueOf());
      } catch (e) {
        console.error(e);
      }
    },
    disabledDate: function disabledDate(current: any) {
      if (!current) return false;

      const day = moment().endOf('day');

      let bool = current.valueOf() >= day.valueOf();

      if (this.rangePickerStart) {
        const isSinglePark = this.isSinglePark;
        const max = isSinglePark
          ? moment(this.rangePickerStart)
              .add(1, 'years')
              .valueOf()
          : moment(this.rangePickerStart)
              .add(30, 'days')
              .valueOf();
        const min = isSinglePark
          ? moment(this.rangePickerStart)
              .subtract(1, 'years')
              .valueOf()
          : moment(this.rangePickerStart)
              .subtract(30, 'days')
              .valueOf();
        const isMin = current.valueOf() < min;
        const isMax = current.valueOf() > Math.min(max, day.valueOf());
        bool = isMin || isMax;
      } else {
        bool = current.valueOf() >= day.valueOf();
      }

      return bool;
    },
    handleOpenChange: function handleOpenChange() {
      this.rangePickerStart = null;
    }
  }
};
